import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO52 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK005-2.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO52
